require('../brokerTransferExternalSteps.scss');
require('./brokerTransferExternalStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classNames = require('classnames');
// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
// @ components
const { InputSafe } = require('commonsComponents/inputSafe');
const BrokerSearchInput = require('../../brokerSearch/brokerSearchInput/brokerSearchInput');
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { BrokerAdvancedSearchExplore } = require('../../brokerAdvancedSearch/brokerAdvancedSearchExplore/brokerAdvancedSearchExplore');
// @ constants
const {
    SECOND_STEP,
    TYPE_STOCKS,
    TYPE_WARRANTS,
    TYPE_ETFS,
    BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT_10,
    BROKER_TRASPASS_EXTERNAL_NUMERIC_VALIDATION_REGEX
 } = require('constants/index');

class BrokerTransferExternalStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filterSettingsOpen: false,
            product: '',
            productName: '',
            showProductLabel: false
        };

        this.conditionalInput = this.conditionalInput.bind(this);
        this.handleTitleAmountInputChange = this.handleTitleAmountInputChange.bind(this);
        this.handleProduct = this.handleProduct.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
    }

    conditionalInput(value, inputOnChange, label, errorState, errorMessage, placeholder, maxLength) {
        const customClass = classNames('broker-transfer-external-step2__text-input-wrapper');
        return (
            <div className={customClass}>
                <InputSafe
                    type="text"
                    value={value}
                    onChange={inputOnChange}
                    label={label}
                    errorState={errorState}
                    errorMessage={errorMessage}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    autoComplete="off"
                />
            </div>
        );
    }

    handleProduct(option) {
        this.props.setISNISO(option.id.isin, option.id.iso, option.currencyCode, option.label);
        this.props.getValueAndEmitionCode();
        this.setState({
            filterSettingsOpen: false,
            product: (option.value ? option.value : ''),
            productName: option.label,
            showProductLabel: !option.value
        })
    }

    handleTitleAmountInputChange(event) {
        const { value } = event.target;
        this.props.setTitleAmount(value.replace(BROKER_TRASPASS_EXTERNAL_NUMERIC_VALIDATION_REGEX, ''));
    }


    handleToggleFilters(evt) {
        (evt) && evt.preventDefault();

        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });
    }

    render() {
        const { immTransferExternalValues } = this.props;
        const titleAmount = immTransferExternalValues.getIn(['steps', SECOND_STEP, 'titleAmount']);
        const titleAmountError = immTransferExternalValues.getIn(['steps', SECOND_STEP, 'titleAmountInputError']);
        const { searchState, onHandleSearch, onHandleSearchReset } = this.props;
        const isLoading = searchState.get('isFetching');
        const results = searchState.get('results');
        const term = searchState.get('term');
        const titleAmountInputErrorMessage = formatText('broker-transferExternalStep2TitleInputError');

        const searchPlaceholder = formatText('broker-searchPlaceholder');
        const searchEmptyText = formatText('broker-transferExternalStep2SearchEmptyText');
        const plansToReturn = [TYPE_STOCKS, TYPE_WARRANTS, TYPE_ETFS];

        const titleAmountInput = this.conditionalInput(
            titleAmount,
            this.handleTitleAmountInputChange,
            formatText('broker-transferExternalAmountLabel'),
            titleAmountError,
            titleAmountInputErrorMessage,
            '0',
            4
        );

        const productLabel = (this.state.showProductLabel ?
            (<div className="broker-transfer-external-step2__product-name-label">
                {formatText('broker-transferExternalStep2SelectedProductLabel')}
                {this.state.productName}
            </div>) : undefined);

        return (
            <article className="broker-transfer-external-steps broker-transfer-external-step2">
                <header className="broker-transfer-external-steps__header">
                    <span className="broker-transfer-external-step2__button-link">
                        <OKButton modifier="link-complementary" onClick={this.handleToggleFilters} size={'compact'}>
                            {formatText('broker-transferExternalStep2SearchLabel')}
                        </OKButton>
                    </span>
                    <FormattedText value="broker-transferExternalStep2Title" className="broker-transfer-external-steps__title" />
                    <FormattedText value="broker-transferExternalStep2SubTitle" className="broker-transfer-external-steps__subtitle" />
                    <h2 className="broker-transfer-external-step2__label">
                        {formatText('broker-transferExternalStep2SubLabel')}
                    </h2>
                </header>
                <section className="broker-transfer-values-step__content">

                    <div className="broker-transfer-external-steps__group-div">
                        <div className="broker-transfer-external-step2__select-wrapper">
                            <BrokerSearchInput
                                results={results}
                                term={term}
                                isLoading={isLoading}
                                selectedValue={this.state.product}
                                onSelection={this.handleProduct}
                                onSearch={onHandleSearch}
                                onReset={onHandleSearchReset}
                                noResultsText={searchEmptyText}
                                placeholder={searchPlaceholder}
                                plansToReturn={plansToReturn}
                                pageSize={BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT_10}
                            />
                            <div className="broker-transfer-external-step2__search-icon">
                                <i className="icon-buscar"></i>
                            </div>
                        </div>
                        {productLabel}
                        {titleAmountInput}
                    </div>
                </section>
                <ModalCustom
                    isOpen={this.state.filterSettingsOpen}
                    onRequestClose={this.handleToggleFilters}
                    scrollable={true}
                >
                    <div className="broker-transfer-external-step2__modal-container modal-scroll-container">
                        <BrokerAdvancedSearchExplore
                            isModal={true}
                            onHandleProductSelect={this.handleProduct}
                        >
                        </BrokerAdvancedSearchExplore>
                    </div>
                </ModalCustom>
            </article>
        )
    }
}

BrokerTransferExternalStep2.propTypes = {
    immTransferExternalValues: PropTypes.object.isRequired,
    setISNISO: PropTypes.func.isRequired,
    setTitleAmount: PropTypes.func.isRequired,
    searchState: PropTypes.object.isRequired,
    onHandleSearch: PropTypes.func.isRequired,
    onHandleSearchReset: PropTypes.func.isRequired,
    getValueAndEmitionCode: PropTypes.func.isRequired
}

module.exports = BrokerTransferExternalStep2;
